import { Component } from '@angular/core';
import { KfiApplicant } from '../../models/kfi-applicant.model';
import { KfiStore } from '../../services/kfi-store';
import { BaseKfiPage } from '../base-kfi-page.component';

@Component({
  selector: 'boi-kfi-applicant',
  templateUrl: './kfi-applicant.page.html',
  styleUrls: ['./../../styles/kfi-pages.scss', './kfi-applicant.page.scss']
})
export class KfiApplicantPage extends BaseKfiPage {
  constructor(protected kfiStore: KfiStore) {
    super(kfiStore);
  }

  public updateApplicantFromFullNameCache(kfiApplicants: Array<KfiApplicant>): void {
    this.kfi.ApplicationCase.AllApplicantsFullNameCache = kfiApplicants
      .map((kfiApplicant) => {
        let fullName = '';
        fullName = kfiApplicant.Forename ? kfiApplicant.Forename : '';
        fullName = kfiApplicant.Surname ? `${fullName} ${kfiApplicant.Surname}` : fullName;
        fullName = fullName.trim();

        return fullName;
      })
      .join(' | ');
  }
}
